import className from "classnames/bind";
import { AnimatePresence, motion } from 'motion/react';
import { GetInducteeLandingQuery } from '@graphqlTypes';
import { MaterialLoader } from "../MaterialLoader";
import { InducteesLandingWrapper } from '../InducteesLandingWrapper';
import { useInducteeLanding } from '@/providers/InducteeLandingContext';

import styles from './InducteeLandingLoader.module.scss'
const cx = className.bind(styles);

interface InducteeLandingLoaderProps {
  inducteeLandingData: GetInducteeLandingQuery["rhPage"]["inducteeLanding"];
}

export default function InducteeLandingLoader({ inducteeLandingData }: InducteeLandingLoaderProps) {
  const { allInductees, inducteesLoading } = useInducteeLanding();
  return (
    <AnimatePresence mode='wait'>
      {inducteesLoading ? (
        <motion.div
          key="inductee-landing-loader"
          className={cx('inductee-landing-loader')}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <MaterialLoader className={cx('spinner')} />
        </motion.div>
      ) : (
        <InducteesLandingWrapper
          inducteeLandingData={inducteeLandingData} 
          inductees={allInductees}
        />
      )}
    </AnimatePresence>
  )
}